module.exports = __webpack_public_path__ + "img/1-5.5ed34194.svg";